import { OFFER_NOTIFICATION_TYPES } from "./notificationTypes";

const OFFER_TYPE_SET = new Set(OFFER_NOTIFICATION_TYPES);

export const isOfferNotificationType = (type) =>
  OFFER_TYPE_SET.has(String(type || ""));

/**
 * Convert profile links to admin equivalents when viewing the admin dashboard.
 * Offer notifications are excluded — they always open profile inbox (product offer threads).
 */
export const convertProfileLinkForAdmin = (link, isAdminRoute) => {
  if (!link || !isAdminRoute) return link;
  if (link.startsWith("/profile/inbox")) {
    return link.replace("/profile/inbox", "/admin/inbox");
  }
  if (link.startsWith("/inbox")) {
    return link.replace("/inbox", "/admin/inbox");
  }
  if (link.startsWith("/profile/offers")) {
    const offerMatch = link.match(/[?&]offer=([^&]+)/);
    const offerId = offerMatch?.[1];
    return offerId ? `/admin-offers?offer=${offerId}` : "/admin-offers";
  }
  return link;
};

/**
 * Resolve where a notification click should navigate.
 * Handles legacy offer notifications that only linked to the offers list.
 */
export const resolveNotificationNavigationPath = (
  notification,
  { isAdminRoute = false } = {}
) => {
  const type = String(notification?.type || "");
  const link = String(notification?.link || "");
  const relatedId =
    notification?.relatedId?.toString?.() || notification?.relatedId || "";

  if (!link && !relatedId) return null;

  if (isOfferNotificationType(type) && relatedId) {
    const conversationMatch = link.match(/[?&]conversation(?:Id)?=([^&]+)/i);
    if (conversationMatch?.[1]) {
      return `/profile/inbox?conversation=${conversationMatch[1]}`;
    }
    if (link.includes("/profile/inbox")) {
      return link;
    }
    return `/profile/inbox?offer=${relatedId}`;
  }

  return convertProfileLinkForAdmin(link, isAdminRoute);
};
